var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("Add Products")]),_vm._v(" "),_c('p',{staticClass:"info"},[_vm._v("\n        Select a product line to the left to display individual products for selection. "),_c('br'),_vm._v("\n        Multiple products can be selected or deselected without altering the submittal by clicking the checkboxes below.\n    ")])])
}]

export { render, staticRenderFns }